import './Avatar.styles.css'

const Avatar = () => {
  return (
    <div className="root" />
  )
}

export default Avatar;
